import { NgModule } from '@angular/core';
import { NgModel, FormControlName } from '@angular/forms';

import { AxisFloatingLabelDirective } from './axis-floating-label.directive';
import { PreventDefaultLinkDirective } from './axisLinkHref.directive';
import { StickyDirective } from './sticky.directive';
import { AxisAccessibilityDirective } from './axis-accessibility.directive';
import { AxisUtilsService } from './utils.service';
import { FileSizePipe } from 'axis-components/components/utilities/file-size.pipe';

@NgModule({
  declarations: [
    AxisFloatingLabelDirective,
    AxisAccessibilityDirective,
    PreventDefaultLinkDirective,
    StickyDirective,
    FileSizePipe
  ],
  exports: [
    AxisFloatingLabelDirective,
    AxisAccessibilityDirective,
    PreventDefaultLinkDirective,
    StickyDirective,
    FileSizePipe
  ],
  providers: [NgModel, FormControlName, AxisUtilsService]
})

export class UtilsModule { }
